export enum ResponseType {
  IDLE = 'idle',
  ERROR = 'error',
  LOADING = 'loading',
  SUCCESS = 'success',
}

type ApiResponseMessageType = {
  readonly text: string;
  readonly type: string;
};

export type ApiResponseType = {
  readonly data: any;
  readonly mcode: number;
  readonly success: boolean;
  readonly message: ApiResponseMessageType;
};

export enum ErrorMessageCode {
  SUCCESS = 0,
  UNKNOWN_SERVER_ERROR = 1,
  WRONG_PARAM = 4,
  AUTH_REQUIRED = 1000,
  INVALID_TOKEN = 1001,
  EXPIRED_TOKEN = 1002,
  WRONG_EMAIL_PASSWORD = 1003,
  EXIST_EMAIL = 1004,
  NOT_EXIST_USER = 2000,
  INVALID_USER = 2001,
}

export enum ErrorMessageName {
  // SUCCESS = 'SUCCESS',
  UNKNOWN_SERVER_ERROR = 'UNKNOWN_SERVER_ERROR',
  WRONG_PARAM = 'WRONG_PARAM_ERROR',
  AUTH_REQUIRED = 'AUTH_REQUIRED_ERROR',
  INVALID_TOKEN = 'INVALID_TOKEN_ERROR',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN_ERROR',
  WRONG_EMAIL_PASSWORD = 'WRONG_EMAIL_PASSWORD_ERROR',
  EXIST_EMAIL = 'EXIST_EMAIL_ERROR',
  NOT_EXIST_USER = 'NOT_EXIST_USER_ERROR',
  INVALID_USER = 'INVALID_USER_ERROR',
}
